import * as fromDatatype from '../datatype-library';

export interface bl_fi_deposit_txn_category_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    txn_category_type: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
}


export class bl_fi_deposit_txn_category_hdr_RowClass implements bl_fi_deposit_txn_category_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    txn_category_type: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
}
